import React, {Component} from 'react';
import './WishlistOverviewScreen.css';
import PortalScreen from "../PortalScreen";
import axios from "axios";
import ProgressIndicator from "../Parts/ProgressIndicator";
import RmButton from "../../Common/RmButton";
import ArrowLink from "../../Common/ArrowLink";
import {Redirect} from 'react-router-dom';
import QuestionItem from "./QuestionItem";
import ErrorMessage from "../../Common/ErrorMessage";

export default class WishlistOverviewScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loadingOverview: false,
            activeTab: null,
            stats: null,
            redirectTo: null,
            questions: null
        };
    }

    componentDidMount() {
        this.refreshOverview(this.props);
    }

    componentWillReceiveProps(nextProps) {
        this.refreshOverview(nextProps);
    }

    refreshOverview(props) {
        if (this.state.loadingOverview) {
            return;
        }

        if (!props) {
            props = this.props;
        }

        let nextTab = "wensen";

        if (props.match.path.indexOf('/praktisch') === 0) {
            nextTab = "praktisch";
        }

        if (nextTab !== this.state.activeTab) {
            this.setState({
                activeTab: nextTab,
                niceTitle: WishlistOverviewScreen.NICE_TITLE_MAP[nextTab],
                redirectTo: null
            });
        }

        let apiUrl = `/wishlist/overview?list=${nextTab}&include_questions=1`;

        this.setState({
            loadingOverview: true
        });

        axios.get(apiUrl)
            .then((res) => {
                let data = res.data;

                if (data.ok) {
                    this.setState({
                        stats: data.stats,
                        questions: data.questions
                    });
                }
            })
            .catch((err) => {
                console.error('Wishlist overview, GET failure:', nextTab, err);
            })
            .then(() => {
                this.setState({
                    loadingOverview: false
                });
            });
    }

    handleWizardStartClick(startOver) {
        let redirectUrl = `/${this.state.activeTab}/wizard`;

        if (startOver) {
            redirectUrl += `?reset=1`;
        }

        this.setState({
            redirectTo: redirectUrl
        });
    }

    handleQuestionClick(question) {
        this.setState({
            redirectTo: `/${this.state.activeTab}/wizard?vraag=${question.id}&soft_reset=1`
        });
    }

    render() {
        if (this.state.redirectTo) {
            return <Redirect to={this.state.redirectTo}/>
        }

        let hasAnsweredAnything = this.state.stats && this.state.stats.answered > 0;

        let hasAnsweredAll = this.state.stats && this.state.stats.qualifying_answered > 0 &&
            this.state.stats.qualifying_answered >= this.state.stats.qualifying;

        let questionItems = [];

        if (this.state.questions) {
            for (let i = 0; i < this.state.questions.length; i++) {
                let question = this.state.questions[i];

                questionItems.push(<QuestionItem question={question} key={`qi${question.id}`}
                                                 onQuestionClick={this.handleQuestionClick.bind(this, question)}
                />);
            }
        }

        let subText = "Leg je wensen voor het afscheid vast.";
        let emptyText = "Je bent nog niet begonnen met het invullen van deze wensenlijst. Klik op onderstaande knop om te starten.";

        if (this.state.activeTab === WishlistOverviewScreen.SECTION_PRACTICAL) {
            subText = "Leg nu een aantal praktische zaken vast m.b.t. je afscheid en daarna";
            emptyText = "Je bent nog niet begonnen met het vastleggen van praktische zaken. Klik op onderstaande knop om te starten.";
        }

        return (
            <PortalScreen tab={this.state.activeTab} title={this.state.niceTitle} isLoading={this.state.loadingOverview}
                          subText={subText}>
                <div className={"WishlistOverviewScreen"}>
                    {this.state.stats &&
                    (
                        <div className={"WishlistOverviewScreen__status"}>
                            {!hasAnsweredAnything && <p>{emptyText}</p>}
                            {hasAnsweredAll && <p>Alle vragen op deze lijst zijn beantwoord.</p>}
                            {hasAnsweredAnything && !hasAnsweredAll && <p>{this.state.stats.qualifying_answered} van {this.state.stats.qualifying} vragen beantwoord</p>}

                            <div className={"WishlistOverviewScreen__status-bar"}>
                                <ProgressIndicator value={this.state.stats.q_percentage}/>
                            </div>

                            <div className={"WishlistOverviewScreen__status-controls"}>
                                {!hasAnsweredAll && <RmButton
                                    label={hasAnsweredAnything ? "Verder met invullen" : "Starten met invullen"}
                                    onClick={this.handleWizardStartClick.bind(this, false)}
                                />
                                }

                                {hasAnsweredAnything &&
                                    <ArrowLink label={"Opnieuw beginnen"}
                                               onClick={this.handleWizardStartClick.bind(this, true)}
                                    />
                                }

                                {hasAnsweredAnything &&
                                <ArrowLink label={"Download lijst als PDF bestand"} href={`${window.API_URL}/wishlist_pdf/${this.state.activeTab}`}
                                           target={"_blank"} icon={<i className={"mdi mdi-file-pdf"}/>}
                                />
                                }
                            </div>
                        </div>
                    )}

                    {this.state.questions && this.state.questions.length > 0 &&
                        <div className={"WishlistOverviewScreen__questions"}>
                            <h2 className={"WishlistOverviewScreen__questions-title"}>
                                <span>Vragen op deze lijst</span>
                                <span className={"count"}>({this.state.questions.length})</span>
                            </h2>
                            <p className={"WishlistOverviewScreen__questions-text"}>Dit is een overzicht van de vragen op deze lijst. Je kunt op een vraag klikken om deze in te vullen, of om een eerder antwoord te wijzigen.</p>
                            <div className={"WishlistOverviewScreen__questions-list"}>
                                {questionItems}
                            </div>
                        </div>
                    }

                    {this.state.questions && this.state.questions.length === 0 &&
                        <ErrorMessage message={"Er zijn op dit moment geen vragen beschikbaar voor deze lijst."}/>
                    }

                    {this.state.stats &&
                    <p className={"WishlistOverviewScreen__questions-text"}>
                        <small className={"wos-filled-notice"}><i className={"mdi mdi-pencil"}/> Heb je de lijst
                            ingevuld? Stuur deze dan op naar een of meerdere mensen die je hiervan op de hoogte wilt
                            brengen of bewaar deze op een voor hen bekende plek. Zo neem je hen een hoop zorgen uit
                            handen mocht je komen te overlijden.
                        </small>
                    </p>
                    }

                </div>
            </PortalScreen>
        );
    }
}

WishlistOverviewScreen.SECTION_WISHES = "wensen";
WishlistOverviewScreen.SECTION_PRACTICAL = "praktisch";
WishlistOverviewScreen.SECTION_DEFAULT = WishlistOverviewScreen.SECTION_WISHES;

WishlistOverviewScreen.NICE_TITLE_MAP = {
    "wensen": "Persoonlijke wensen",
    "praktisch": "Praktische zaken",
};



// WEBPACK FOOTER //
// ./src/Portal/Wishlist/WishlistOverviewScreen.js